/**
 * LocationsTab Component
 * Program locations
 */

import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import styles from './TabStyles.module.css';

const LocationsTab = ({ program }) => {
  const locations = program?.locations || [];

  // Helper to safely render address (could be string or object)
  const renderAddress = (address) => {
    if (!address) return 'No address';
    if (typeof address === 'string') return address;
    if (typeof address === 'object') {
      // Handle object with city, state, country, etc.
      const parts = [address.street, address.city, address.state, address.country]
        .filter(val => typeof val === 'string' && val);
      return parts.length > 0 ? parts.join(', ') : 'Location available';
    }
    return 'No address';
  };

  return (
    <div className={styles.tabContainer}>
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Locations</h3>
        
        <div className={styles.locationList}>
          {locations.length > 0 ? (
            locations.map((location, index) => (
              <div key={index} className={styles.locationItem}>
                <FaMapMarkerAlt className={styles.locationIcon} />
                <p className={styles.locationAddress}>{renderAddress(location.address)}</p>
              </div>
            ))
          ) : (
            <p className={styles.emptyMessage}>No locations available.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default LocationsTab;










